'use strict';
var parent = require('../../actual/object/values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/values.js
// module id = 368
// module chunks = 0